import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import PatisserieFormModal from "./PatisserieFormModal";
import PatisserieTable from "./PatisserieTable";

const Patisserie = () => {
  const [patisserieItems, setPatisserieItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchPatisserieItems();
  }, []);

  const fetchPatisserieItems = async () => {
    try {
      const response = await api.get("/patisserie");
      setPatisserieItems(response.data);
    } catch (error) {
      console.error("Error fetching patisserie items:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/patisserie/${id}`);
      setPatisserieItems(patisserieItems.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting patisserie item:", error);
    }
  };

  return (
    <div>
      <h1>Manage Patisserie Items</h1>
      <button onClick={() => setIsModalOpen(true)}>Add Patisserie Item</button>
      <PatisserieTable
        data={patisserieItems}
        onDelete={handleDelete}
        onEdit={(item) => {
          setSelectedItem(item);
          setIsModalOpen(true);
        }}
      />
      {isModalOpen && (
        <PatisserieFormModal
          onClose={() => {
            setIsModalOpen(false);
            setSelectedItem(null);
          }}
          onSave={fetchPatisserieItems}
          patisserieItem={selectedItem}
        />
      )}
    </div>
  );
};

export default Patisserie;
